import React, { PureComponent } from 'react';
import { Typeahead } from 'react-typeahead';
import axios from 'axios';

class PostcodeField extends PureComponent {
    state = {
        postcodes: [],
    }

    componentDidMount() {
        const input = document.querySelector('.typeahead > input');
        input.id = 'postcodeTypeahead';
        input.setAttribute('autocomplete', 'off');
    }
    
    handleSelection(selected) {
        const { postcodes } = this.state;
        const { setPostcode } = this.props;
        const selectedPostcode = postcodes.find(option => option.postcode == selected);
        const input = document.querySelector('.typeahead > input');
        
        setPostcode(selectedPostcode.postcode);
        input.blur();
    }
    
    
    async handleKeyUp() {
        const input = document.querySelector('.typeahead > input');
        const value = input.value;
        const { postcodes } = this.state;
        const { setPostcode } = this.props;

        if (value != '' && value.length > 0) {
            const response = await  axios.get(process.env.CMS_URL + '/getOptions');
            const data = response.data;
            this.setState({
                postcodes: data.postcodes.filter(pcode => pcode.postcode.includes(value.toUpperCase()))
            });
        } else {
            this.setState({
                postcodes: []
            });
            setPostcode(null);
        }
    }

    handleBlur() {
        this.setState({
            postcodes: []
        });
    }

    render() {
        const { postcode, setPostcode } = this.props;
        const { postcodes } = this.state;

        return (
            <div className="fieldwrap __postcode">
                <label htmlFor="postcodeTypeahead">
                    What is the first part of your home postcode (e.g., CF for Cardiff, M for Manchester)? Please choose one from those listed.
                </label>

                <Typeahead
                    onKeyUp={() => this.handleKeyUp()}
                    options={postcodes.map(postcode => postcode.postcode)}
                    value={postcode ? postcode : ''}
                    onOptionSelected={(postcode) => this.handleSelection(postcode)}
                    onBlur={() => this.handleBlur()}
                />
            </div>
        );
    }
}

export default PostcodeField;



// WEBPACK FOOTER //
// ./src/Form/PostcodeField.js